import { Form } from 'antd';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useWorkstations } from '@/hooks/v1/useWorkstations';

interface WorkstationProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useWorkstation({ fieldName }: WorkstationProps) {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const lineId = useWatch(field ? [field, 'line_id'] : 'line_id');
	const workstationId = useWatch(field ? [field, 'workstation_id'] : 'workstation_id');

	const {
		isFetching,
		data: workstations,
		isError
	} = useWorkstations({
		organization_id: organization.id!,
		company_id: company.id!,
		line_id: lineId
	});

	const isDisabled = !lineId;

	function handleSelectWorkstation(id: string): void {
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], id);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	function handleClearWorkstation(): void {
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	const items =
		workstations?.map((workstation: { id: string; name: string }) => ({
			value: workstation.id,
			label: workstation.name
		})) || [];

	return {
		items,
		workstationId,
		lineId,
		isFetching,
		isError,
		isDisabled,
		handleSelectWorkstation,
		handleClearWorkstation
	};
}
